import axios from './axios';

export const fetchStoreRotation = async () => {
    const response = await axios.get('/store/rotation');
    return response.data;
};
